function renderDate(data, type, row, meta) {
    if (data && type == "display") {
        return new Date(Date.parse(data)).toLocaleDateString();
    }
    return data;
}

function renderDateTime(data, type, row, meta) {
    if (data && type == "display") {
        // 2/28/2016 8:00PM
        var dt = moment.parseZone(data);
        return dt.format("M/D/YYYY h:mmA");
    }
    return data;
}

function renderCheckbox(data, type, row, meta) {
    if (type == "display") {
        if (data == true)
        {
            return "<input type='checkbox' checked disabled />";
        }
        return "<input type='checkbox' disabled />";
    }
    return data;
}

function renderEditUrl(data, type, row, meta) {
    if (data && type == "display") {
        var url = row.EditUrl;
        return "<a href='" + url + "'>" + data + "</a>";
    }
    return data;
}

function renderViewUrl(data, type, row, meta) {
    if (data && type == "display") {
        var url = row.ViewUrl;
        return "<a href='" + url + "'>" + data + "</a>";
    }
    return data;
}

function renderViewExternalUrl(data, type, row, meta) {
    if (data && type == "display") {
        var url = row.ViewUrl;
        return "<a href='" + url + "' target='_blank'>" + data + "</a> <span class='glyphicon glyphicon-new-window' aria-hidden='true'></span>";
    }
    return data;
}

function renderPercentage(data, type, row, meta) {
    if (type == "display") {
        if (data) {
            return (data * 100).toFixed(2) + "%";
        } else {
            return (0).toFixed(2) + "%";
        }
    }
    return data;
}

function renderCurrency(data, type, row, meta) {
    if (type == "display") {
        if (data) {
            return data.toFixed(2);
        } else {
            return (0).toFixed(2);
        }
    }
    return data;
}